import { render, staticRenderFns } from "./FeatureTable.vue?vue&type=template&id=2e382df1&scoped=true"
import script from "./FeatureTable.vue?vue&type=script&lang=js"
export * from "./FeatureTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureTable.vue?vue&type=style&index=0&id=2e382df1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e382df1",
  null
  
)

export default component.exports